module.exports = __webpack_public_path__ + "static/media/W09F2162-WEB5.7bf56acd.svg";